import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)
var url = window.location.href
var strs = url.split("?")
var gcm = strs[1].split("=")[1]
console.log('gcm', gcm)
// localStorage.setItem('gcm', JSON.stringify(gcm))
// const number_id = JSON.parse(localStorage.getItem('gcm'))
// console.log('number_id',number_id)
const routes = [
    {
        path: `/number=${gcm}`,
        name: '/',
        component: re => require(['@/components/LayContentAll.vue'], re),
        children: [
            {
                path: `/index`,
                name: 'index',
                meta: {
                    title: '汉语首页',
                    type: 0,//用于记录用户行为  1书籍 2杂志
                },
                component: () => import('@/views/AqtIndex/ZH/index.vue'),
            },
            {
                path: '/BooksListZh',
                name: 'BooksListZh',
                meta: {
                    title: '书籍列表',
                    type:1
                },
                component: () => import('../views/Books/ZH/BooksListZh.vue'),
            },
            {
                path: '/BookDetailsZh',
                name: 'BookDetailsZh',
                meta: {
                    title: '书籍详情',
                    type:1
                },
                component: () => import('../views/Books/ZH/BookDetailsZh.vue'),
            },
            {
                path: '/CatalogDatabaseListZh',
                name: 'CatalogDatabaseListZh',
                meta: {
                    title: '目录数据库',
                    type:12
                },
                component: () => import('../views/CatalogDatabase/ZH/CatalogDatabaseListZh.vue'),
            },
            {
                path: '/JournalListZh',
                name: 'JournalListZh',
                meta: {
                    title: '期刊列表',
                    type:2
                },
                component: () => import('../views/Journal/ZH/JournalListZh.vue'),
            },
            {
                path: '/JournalDetailsZh',
                name: 'JournalDetailsZh',
                meta: {
                    title: '期刊详情',
                    type:2
                },
                component: () => import('../views/Journal/ZH/JournalDetailsZh.vue'),
            },
            {
                path: '/JournalMueZh',
                name: 'JournalMueZh',
                meta: {
                    title: '期刊目录详情',
                    type:2
                },
                component: () => import('../views/Journal/ZH/JournalMueZh.vue'),
            },
            {
                path: '/paperListZh',
                name: 'paperListZh',
                meta: {
                    title: '论文列表',
                    type:12
                },
                component: () => import('../views/Paper/ZH/paperListZh.vue'),
            },
            {
                path: '/paperDetailsZh',
                name: 'paperDetailsZh',
                meta: {
                    title: '论文详情',
                    type:12
                },
                component: () => import('../views/Paper/ZH/paperDetailsZh.vue'),
            },
        ]
    },
    {
        path: '/login_zh',
        name: 'login_zh',
        meta: {
            title: '登录',
            type: 0,//用于记录用户行为  1书籍 2杂志
        },
        component: re => require(['../views/Login/ZH/login_zh.vue'], re),
    },
]

export default new Router({
    routes
    // mode: 'history',
})


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
